import _ from 'lodash';
import { FormErrors } from 'redux-form';

import { FilterEvents } from '../../../../../types/filter-events';

import { ReplicationFormData } from './edit-replication-form.types';
import { IntlShape } from 'react-intl/src/types';

export function getInitialValues(): ReplicationFormData {
  return {
    bucketName: '',
    accessKey: '',
    accessSecretKey: '',
    accessJson: '',
    name: '',
    active: true,
    destination: '',
    // TODO: change it
    triggerType: FilterEvents.FileCreated,
    bodyFilters: [],
  };
}

export const validateReplicationEditForm =
  (intl: IntlShape) =>
  (values: ReplicationFormData): FormErrors<ReplicationFormData> => {
    return {
      bucketName: _.isEmpty(values.bucketName)
        ? intl.formatMessage({
            id: 'replications.details.new-replication.bucket.errors.empty',
          })
        : undefined,
      destination: _.isEmpty(values.destination) ? 'no destination' : undefined,
      name: _.isEmpty(_.trim(values.name))
        ? intl.formatMessage({
            id: 'replications.details.new-replication.name.errors.empty',
          })
        : undefined,
      accessKey:
        _.isEmpty(values.accessKey) && !_.isEmpty(values.accessSecretKey)
          ? intl.formatMessage({
              id: 'replications.details.edit-replication.key.errors.empty',
            })
          : undefined,
      accessSecretKey:
        _.isEmpty(values.accessSecretKey) && !_.isEmpty(values.accessKey)
          ? intl.formatMessage({
              id: 'replications.details.edit-replication.secret-key.errors.empty',
            })
          : undefined,
    };
  };
